import { Box } from '@mui/material';
import LogoImage from '../../../images/cpq-branding-logo.PNG';
import CpqLogo from '../../../images/wpo-logo.jpg';
import { LogoWrapper } from "./logoStyled";
import { useSelector } from 'react-redux';

const Logo = () => {
    
    return (
        <>
            <LogoWrapper>
                <Box className="headerFirstLogo">
                    <a href={'/'}>
                        <img src={LogoImage} alt="headerLogo" />
                    </a>
                </Box>
                <Box className="headerSecondLogo">
                    <a href={'/'}>
                        <img src={CpqLogo} alt="headerLogo" />
                    </a>
                </Box>
            </LogoWrapper>
        </>
    )
}

export default Logo;